import { Category964Enum } from "Shared/Types/fleetmanagementapi";

export const categoryColors: Record<Category964Enum, string> = {
  NEW: "green",
  IMPROVED: "blue",
  UPDATE: "orange",
  MAINTENANCE: "gray",
  DEPRECATED: "red",
};
